import React, { SyntheticEvent, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { SelectInput, TextInput } from "fe-shared/src/components";

import { AdjustmentMaterial } from "../modules/types";
import styles from "../EditInventoryAdjustmentDialog.module.scss";

interface Option {
  label: string;
  value: string | number;
}

interface Props {
  adjustmentMaterial: AdjustmentMaterial;
  valueKey: string;
  isPositive: boolean;
  isNegative: boolean;
  errors: any;
  onChange: (key: string, value: unknown, isValidated?: boolean) => void;
  onBlur: (key: string) => void;
  materialOptions: Option[];
}

const MaterialRow = ({
  adjustmentMaterial,
  valueKey,
  isNegative,
  isPositive,
  errors,
  onBlur,
  onChange,
  materialOptions,
}: Props) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const { isOriginal, materialName, materialCode, units } = adjustmentMaterial;
  const selectValueKey = `${valueKey}.materialCode`;
  const amountValueKey = `${valueKey}.units.unitQuantity`;
  const amountFormErrors = errors[amountValueKey];

  const mask = useMemo(() => {
    let prefix = "";

    if (isPositive) {
      prefix = "+";
    }

    if (isNegative) {
      prefix = "-";
    }

    return `${prefix}999999999999`;
  }, [isPositive, isNegative]);

  return (
    <>
      <div className={styles.formSelectContainer}>
        {isOriginal ? (
          <span className={styles.formSelectText}>{materialName}</span>
        ) : (
          <SelectInput
            value={materialCode}
            options={materialOptions}
            id={selectValueKey}
            onChange={(
              event: SyntheticEvent<Element, Event>,
              value: unknown
            ): void => {
              onChange(selectValueKey, value, true);
            }}
          />
        )}
      </div>
      <TextInput
        id={amountValueKey}
        ref={inputRef}
        mask={mask}
        width={100}
        placeholder="0"
        value={units.unitQuantity}
        isError={!!amountFormErrors?.length}
        errorText={t(amountFormErrors)}
        transformValue={(value: string) => Number(value).toString()}
        wrapperClassName={styles.formInputWrapper}
        inputClassName={classnames(styles.formInput, {
          [styles.formInputPositive]: isPositive,
          [styles.formInputNegative]: isNegative,
        })}
        onChange={(e, value) => {
          onChange(amountValueKey, value, false);
        }}
        onBlur={() => onBlur(amountValueKey)}
      />
    </>
  );
};

export default MaterialRow;
